<template>
    <div class="statistics-container d-flex align-items-center">
        <UIGridContainer>
            <UIGridRow class="overflow-hidden">
                <UIGridCol md="4" class="statistic mt-md-0 mr-0">
                    <UIImage
                        src="images/about-page/icon-products.png"
                        :resource="true"
                        :width="120"
                        :ratio="'15:13'"
                        :responsive-widths="[480, 320]"
                    />
                    <UIAnimatedNumber :number="products" :speed="140" class="statistic-text mt-md-3 mt-lg-0">
                        <br /><span>{{ translate('aboutstatistics.statistic1') }}</span>
                    </UIAnimatedNumber>
                </UIGridCol>
                <UIGridCol md="4" class="statistic mt-md-0 mr-0">
                    <UIImage
                        src="images/about-page/icon-customers.png"
                        :resource="true"
                        :width="120"
                        :ratio="'15:13'"
                        :responsive-widths="[480, 320]"
                    />
                    <UIAnimatedNumber :number="reviews" :speed="32" :step="65" class="statistic-text mt-md-3 mt-lg-0">
                        <br /><span>{{ translate('aboutstatistics.statistic2') }}</span>
                    </UIAnimatedNumber>
                </UIGridCol>
                <UIGridCol md="4" class="statistic mt-md-0 mb-md-0 mr-0">
                    <UIImage
                        src="images/about-page/icon-employees.png"
                        :resource="true"
                        :width="120"
                        :ratio="'15:13'"
                        :responsive-widths="[480, 320]"
                    />
                    <UIAnimatedNumber :number="teamMembers" :speed="150" class="statistic-text mt-md-3 mt-lg-0">
                        <br /><span>{{ translate('aboutstatistics.statistic3') }}</span>
                    </UIAnimatedNumber>
                </UIGridCol>
            </UIGridRow>
        </UIGridContainer>
    </div>
</template>

<script>
import { UIGridContainer, UIAnimatedNumber, UIImage, UIGridRow, UIGridCol } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';
export default {
    components: {
        UIAnimatedNumber,
        UIImage,
        UIGridContainer,
        UIGridRow,
        UIGridCol,
    },
    mixins: [TranslationMixin],
    props: {
        products: {
            type: Number,
            required: true,
        },
        reviews: {
            type: Number,
            required: true,
        },
        teamMembers: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'sass:math';
.statistics-container {
    background-color: $color-section-bg;
    position: relative;
    overflow: hidden;

    margin-top: 4rem;

    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;

        background-image: url(https://images.dundle.com/resources/images/about-page/pattern-dundle-white.svg);
        background-position: center center;
        background-size: 125px 131px;
        opacity: 0.15;
        background-repeat: repeat;

        // Enable when parallax is fixed
        // transform: translateZ(-3px) scale(1.8);
    }

    @media screen and (min-width: 768px) {
        margin-top: 7rem;
        height: 21.3rem;
    }
}

.statistic {
    display: flex;
    flex-direction: row;

    margin-top: 4rem;

    img {
        width: 120px;
        aspect-ratio: math.div(15, 13);

        @media (min-width: 576px) and (max-width: 768px) {
            align-self: center;
        }
    }

    p::first-line {
        font-size: 1.8rem;
    }

    &:last-of-type {
        margin-bottom: 4rem;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
}

.statistic-text {
    margin-left: 1rem;
    font-size: 2.667rem;
    line-height: 2.333rem;
    font-weight: 700;
    color: $color-text-inverted;

    display: flex;
    align-items: center;

    min-width: 160px;

    span {
        font-size: 1.333rem;
    }

    @media screen and (min-width: 768px) {
        font-size: 1.8rem;
        line-height: 1.5rem;

        span {
            font-size: 1.3rem;
        }
    }

    @media (min-width: 576px) and (max-width: 768px) {
        text-align: center;
        display: flex;
        justify-content: center;
        margin-left: 0;
    }
}
</style>

<i18n></i18n>
